import React from "react";
import Chips, {ChipsContentType, ChipsTypes} from "../../../../../../../../components/base/chips/chips";
import TagChipsContent from "../../../../../../../../components/app-specific/chips-contents/tag-chips-content";
import Banner from "../../../../../../../../components/app-specific/banner";

const UserHomepageControlPanelBannerEntity = ({banner}) => {
    return (
        <>
            <div className={'User-homepage-control-panel-banner'}>
                <Banner
                    url={banner?.imageName}
                    withShadow
                />
                <div className={'tags-container'}>
                    {
                        banner?.tags?.map(tag => (
                            <Chips
                                key={tag.id}
                                className={'tag'}
                                type={ChipsTypes.none}
                                contentType={ChipsContentType.element}
                                content={<TagChipsContent tag={tag} useIcon/>}
                            />
                        ))
                    }
                </div>
            </div>
        </>
    )
}

export default UserHomepageControlPanelBannerEntity;
